import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const documentEndpoint = '/api/poaDocumentosMedios';
const actualizarTipo = '/api/actualizarTipoEntrega';
const actualizarEstado = '/api/actualizarEstadoActa';


// Función para obtener datos de POA enviando el 'path' en el cuerpo de la solicitud
export const fetchPoaDataByPath = async (path) => {
  try {
    // Log para verificar el valor del 'path' antes de la solicitud

    // Realiza una solicitud POST enviando el 'path' en el cuerpo
    const response = await axios.post(`${baseUrl}${documentEndpoint}`, { path });

    return response.data; // Retorna los documentos obtenidos
  } catch (error) {
    console.error('Error fetching POA data by path:', error);
    throw error;
  }
};


export const ActualizarTipoEntrega = async (id, tipoEntrega) => {
  try {
    const response = await axios.put(`${baseUrl}${actualizarTipo}`, { id, tipoEntrega });
    return { success: true, data: response.data };
  } catch (error) {
    if (error.response) {
      // El servidor respondió con un status diferente de 2xx
      console.error('Error updating delivery type:', error.response.data);
      const status = error.response.status;
      const message = error.response.data.error || 'Error desconocido';
      if (status === 400) {
        return { success: false, status, message: `Error de solicitud: ${message}` };
      } else if (status === 404) {
        return { success: false, status, message: `No encontrado: ${message}` };
      } else if (status === 500) {
        return { success: false, status, message: `Error del servidor: ${message}` };
      } else {
        return { success: false, status, message: `Error: ${message}` };
      }
    } else {
      // Error de red u otro error fuera de respuesta del servidor
      console.error('Error de red:', error);
      return { success: false, status: null, message: 'Error de red o de conexión' };
    }
  }
};


export const ValidarEstadoActa = async (id, estadoActa) => {
  try {
    const response = await axios.put(`${baseUrl}${actualizarEstado}`, { id, estadoActa });
    return { success: true, data: response.data };
  } catch (error) {
    if (error.response) {
      console.error('Error validating act state:', error.response.data);

      const status = error.response.status;
      const message = error.response.data.error || 'Error desconocido';

      if (status === 400) {
        return { success: false, status, message: `Error de solicitud: ${message}` };
      } else if (status === 404) {
        return { success: false, status, message: `No encontrado: ${message}` };
      } else if (status === 500) {
        return { success: false, status, message: `Error del servidor: ${message}` };
      } else {
        return { success: false, status, message: `Error: ${message}` };
      }
    } else {
      console.error('Error de red:', error);
      return { success: false, status: null, message: 'Error de red o de conexión' };
    }
  }
};

